const RoundArrow = ({ styles }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332ZM8.3079 7.0579C8.55197 6.81382 8.9477 6.81382 9.19178 7.0579L11.6918 9.55789C11.9359 9.80197 11.9359 10.1977 11.6918 10.4418L9.19178 12.9418C8.9477 13.1859 8.55197 13.1859 8.3079 12.9418C8.06382 12.6977 8.06382 12.302 8.3079 12.0579L10.366 9.99984L8.3079 7.94178C8.06382 7.6977 8.06382 7.30197 8.3079 7.0579Z"
        fill="#00003A"
        {...styles}
      />
    </svg>
  )
}

export default RoundArrow